export default __webpack_public_path__ + "static/media/curiosity-search-pana.5725afb0.png";